import { useMemo, useState } from "react";

import { Outlet, Navigate, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";

import { selectIsAuthenticated } from "@/redux/authentication/selectors.js";
import { useResponsive } from "@/shared/hooks/useBreakpoints";
import BrandingPanel from "./BrandingPanel";
import AlternateAction from "./AlternateAction";
import { OnboardingLayoutContext } from "./context";

import "./styles.css";

const OnboardingLayout = () => {
  const [searchParams] = useSearchParams();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const { isDesktopOrLaptop } = useResponsive();
  const [hideAlternateAction, setHideAlternateAction] = useState(false);

  const contextValue = useMemo(() => ({ setHideAlternateAction }), []);

  if (isAuthenticated) {
    return <Navigate to={searchParams.get("redirect_to") ?? "/"} />;
  }

  return (
    <OnboardingLayoutContext.Provider value={contextValue}>
      <div className="onboarding-layout flex">
        {isDesktopOrLaptop && <BrandingPanel />}
        <div className="onboarding-layout__main flex flex-col flex-1">
          <main className="onboarding-layout__content flex flex-1 items-start justify-center">
            <div className="onboarding-layout__form-card flex flex-col self-center gap-200">
              <Outlet />

              {!hideAlternateAction && <AlternateAction />}
            </div>
          </main>
        </div>
      </div>
    </OnboardingLayoutContext.Provider>
  );
};

export default OnboardingLayout;
